import React, { useEffect, useState } from "react";
import {
  addAccountActivity,
  getAccountActivities,
  getEmailAccounts,
} from "../../Api/Api";
import { getAccessToken, setAdminId, setRole } from "../../Auth/Auth";
import {
  CircularProgress,
  Grid,
  TablePagination,
  Typography,
} from "@mui/material";
import { accountsGrid, activityText, roleText } from "../../Theme/Theme";
import { AccountIcon } from "../../Icons/Icons";
import { useNavigate } from "react-router-dom";
import { CustomDivider } from "../../InputComponents/CustomDivider";
import { AccountTopNav } from "../../UIComponents/AccountTopNav";

export function SelectAccount(props) {
  const [accounts, setAccounts] = useState([]);
  const [loading, setLoading] = useState(false);
  const [accountActivities, setAccountActivities] = useState([]);
  const [page, setPage] = useState(0);

  const navigate = useNavigate();

  const selectAccount = async (role, id) => {
    setRole(role);
    setAdminId(id);
    const data = { email: localStorage.getItem("email"), clinicId: id };
    const token = getAccessToken();
    setLoading(true);
    const res = await addAccountActivity(data, token);
    if (res.message === "Success") {
      setLoading(false);
      navigate("/clinicUser/dashboard");
    }
  };

  const filteredActivities = accountActivities.filter(
    (a) => a.clinicName !== null
  );

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };
  const rowsPerPage = 5;

  const paginatedActivities = filteredActivities.slice(
    page * rowsPerPage,
    page * rowsPerPage + rowsPerPage
  );

  const logOut = () => {
    localStorage.clear();
    navigate("/");
  };

  useEffect(() => {
    const token = getAccessToken();
    const email = localStorage.getItem("email");
    const getAccounts = async () => {
      setLoading(true);
      const accountsOfTheUser = await getEmailAccounts(email, token);
      if (accountsOfTheUser.message === "Success") {
        const validAccounts = accountsOfTheUser.content.filter(
          (a) => a.role !== 0 && a.role !== 2 && a.role !== 100
        );
        if (validAccounts.length === 1) {
          selectAccount(validAccounts[0]["role"], validAccounts[0]["clinicId"]);
          return;
        }
        setAccounts(validAccounts);
        setLoading(false);
      }
    };
    const getAccountsActivities = async () => {
      const activity = await getAccountActivities(email, token);
      if (activity.message === "Success") {
        const sortedActivities = activity.content.sort(
          (a, b) => new Date(b.dateTime) - new Date(a.dateTime)
        );

        const seenClinicIds = new Set();
        const uniqueActivities = sortedActivities.filter((item) => {
          if (seenClinicIds.has(item.clinicId)) {
            return false;
          } else {
            seenClinicIds.add(item.clinicId);
            return true;
          }
        });

        setAccountActivities(uniqueActivities);
      }
    };

    getAccounts();
    getAccountsActivities();
  }, []);
  return (
    <>
      <AccountTopNav loading={loading} logOut={() => logOut()} />
      {loading === true ? (
        <Grid
          container
          style={{
            paddingTop: "30px",
            width: "100%",
          }}
        >
          <Grid
            item
            xs={12}
            md={12}
            lg={12}
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              minHeight: "70vh",
              color: "rgba(0, 0, 0, 0.5)",
            }}
          >
            <CircularProgress size={30} />
          </Grid>
        </Grid>
      ) : (
        <>
          <Grid container style={{ padding: "30px", paddingTop: "110px" }}>
            <Grid item sm={12} xs={12} md={12} lg={12}></Grid>

            <Grid
              item
              sm={12}
              xs={12}
              md={12}
              lg={12}
              style={{ paddingBottom: "25px" }}
            >
              <Typography variant="h6">Your Access</Typography>
              <Typography
                variant="subtitle2"
                style={{
                  display: "inline",
                  color: "#949697",
                }}
              >
                Access for your authorized clinics
              </Typography>
            </Grid>
            <Grid container spacing={1}>
              {accounts.map((a, i) => {
                return (
                  <Grid
                    key={i}
                    item
                    sm={12}
                    xs={12}
                    md={3}
                    lg={3}
                    onClick={() => selectAccount(a.role, a.clinicId)}
                  >
                    <Grid container sx={accountsGrid}>
                      <Grid
                        item
                        sm={3}
                        xs={3}
                        md={5}
                        lg={4}
                        style={{ textAlign: "center" }}
                      >
                        <AccountIcon type={"ACCOUNT_PAGE"} />
                      </Grid>
                      <Grid
                        item
                        sm={9}
                        xs={9}
                        md={7}
                        lg={8}
                        style={{ paddingLeft: "5px", paddingTop: "10px" }}
                      >
                        <Typography variant="subtitle2">
                          {a.clinicName}
                        </Typography>
                        <Typography style={roleText}>
                          {a.role === 1
                            ? "Clinic Owner"
                            : a.role === 5
                            ? "Physiotherapist"
                            : a.role === 6
                            ? "Clinic Admin"
                            : "Reporting Staff"}
                        </Typography>
                      </Grid>
                    </Grid>
                  </Grid>
                );
              })}
            </Grid>

            <Grid
              item
              sm={12}
              xs={12}
              md={12}
              lg={12}
              style={{
                paddingTop: "15px",
              }}
            >
              {accountActivities.length > 0 && (
                <div
                  style={{
                    backgroundColor: "white",
                    padding: "20px",
                    borderRadius: "8px",
                  }}
                >
                  <Grid
                    item
                    sm={12}
                    xs={12}
                    md={12}
                    lg={12}
                    style={{ paddingBottom: "25px" }}
                  >
                    <Typography variant="subtitle2">Recent Activity</Typography>
                  </Grid>

                  {paginatedActivities.map((ac, i) => {
                    const formatDate = (dateString) => {
                      const date = new Date(dateString);
                      const now = new Date();

                      const isSameDay = (d1, d2) =>
                        d1.getFullYear() === d2.getFullYear() &&
                        d1.getMonth() === d2.getMonth() &&
                        d1.getDate() === d2.getDate();

                      const yesterday = new Date();
                      yesterday.setDate(now.getDate() - 1);

                      const hours = date.getHours();
                      const minutes = date.getMinutes();
                      const ampm = hours >= 12 ? "PM" : "AM";
                      const formattedHour = hours % 12 || 12;
                      const formattedMinute =
                        minutes < 10 ? "0" + minutes : minutes;
                      const timeString = `${formattedHour}:${formattedMinute} ${ampm}`;

                      if (isSameDay(date, now)) {
                        return `Today, ${timeString}`;
                      } else if (isSameDay(date, yesterday)) {
                        return `Yesterday, ${timeString}`;
                      } else {
                        const month = date.toLocaleString("default", {
                          month: "short",
                        });
                        const day = date.getDate();
                        return `${month} ${day}, ${timeString}`;
                      }
                    };

                    return (
                      <Grid container key={i}>
                        <Grid item sm={6} xs={6} md={6} lg={6}>
                          <Typography style={activityText}>
                            {ac.clinicName}
                          </Typography>
                        </Grid>
                        <Grid
                          item
                          sm={6}
                          xs={6}
                          md={6}
                          lg={6}
                          style={{ textAlign: "right" }}
                        >
                          <Typography style={activityText}>
                            {formatDate(ac.dateTime)}
                          </Typography>
                        </Grid>
                        <CustomDivider width={"100%"} />
                      </Grid>
                    );
                  })}
                </div>
              )}
            </Grid>
            <Grid
              container
              justifyContent="right"
              style={{ marginTop: "20px" }}
            >
              {accountActivities.length > 0 && (
                <TablePagination
                  component="div"
                  count={filteredActivities.length}
                  page={page}
                  onPageChange={handleChangePage}
                  rowsPerPage={5} // Fixed to 5
                  rowsPerPageOptions={[]} // Hides the dropdown
                  labelRowsPerPage="" // Optional: hide the label
                />
              )}
            </Grid>
          </Grid>
        </>
      )}
    </>
  );
}
